import styled from 'styled-components';
import { AIGradientColors, MediaQuery, NeutralColors } from 'theme';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  max-width: 804px;
  margin: auto;
  max-height: 480px;

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    margin-top: 24px;
    justify-content: space-between;
    max-height: none;
    gap: 12px;
  }
`;

const ConversationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const Title = styled.h1`
  text-align: center;

  font-family: 'Noto Sans';
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: -0.63px;
  background: ${AIGradientColors[60]};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Tag = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  height: 56px;
  border-radius: 14px;
  border: 1px solid ${NeutralColors[20]};
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: ${NeutralColors[10]};
  }

  svg {
    width: 20px;
    margin-right: 8px;
  }

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    padding: 16px 12px;
    height: 50px;
  }
`;

const VoiceContainer = styled.div`
  display: none;
  flex-direction: row;
  gap: 12px;
  justify-content: start;
  align-items: center;
  padding: 8px 0px;
  width: 100%;
  border-top: 1px solid ${NeutralColors[20]};

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    display: flex;
  }
`;

const VoiceDescription = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 20px;
  letter-spacing: -0.105px;
`;

const VoiceTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

const ContainerTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
`;

export {
  Container,
  ContainerTags,
  ConversationContainer,
  Tag,
  Title,
  VoiceContainer,
  VoiceDescription,
  VoiceTitle,
};
